import mapStyles from './data/mapStyles';
export class Map {
    constructor(element) {
        this.el = element
        this.map = null;
        this.bounds = null;
        this.markers = Array.from(element.querySelectorAll('[data-js-map-marker]'));
//        console.log(this.markers);
    }
    closeAllInfoWindows() {
        Array.from(this.markers).forEach((marker) => {
            marker.$marker.infoWindow.close();
        });
    }
    selectMarker($marker) {
        $marker.infoWindow.open(this.map, $marker);
        //this.closeAllInfoWindows();
        //this.map.fitBounds(this.bounds);
        //setTimeout(() => {
        //    this.map.setZoom(16);
        //    this.map.panTo(new google.maps.LatLng($marker.position.lat(), $marker.position.lng()));
        //    setTimeout(() => {
        //        $marker.infoWindow.open(this.map, $marker);
        //    }, 1000);
        //}, 1000)
    }
    updateMarkerBounds() {
        this.bounds = new google.maps.LatLngBounds();
        this.markers.forEach((marker) => {
            const LatLng = new google.maps.LatLng(marker.$marker.position.lat(), marker.$marker.position.lng());
            this.bounds.extend(LatLng);
        });
    }
    initMap() {
        if (!this.el) return false;

        this.map = new google.maps.Map(this.el, {
            zoom: 10,
            styles: mapStyles,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
        });

        const isContactPage = document.querySelector('.header--animated[data-header-slug="kontakt"]');
        const markerSvg = isContactPage ?
            `${window.location.origin}/frontend/img/custom/logo--centrala--black.svg` :
            `${window.location.origin}/frontend/img/icons/map-marker.svg`;

        const markerImage = {
            url: markerSvg,
            scaledSize: isContactPage ? new google.maps.Size(200, 200) : new google.maps.Size(50, 68),
        };

        this.markers.forEach((marker, markerIndex) => {

            marker.$marker = new google.maps.Marker({
                position: new google.maps.LatLng(parseFloat(marker.getAttribute('data-lat')), parseFloat(marker.getAttribute('data-lng'))),
                map: this.map,
                animation: google.maps.Animation.DROP,
                icon: markerImage,
            });
            marker.$marker.infoWindow = new google.maps.InfoWindow({
                content: marker.innerHTML,
                map: this.map
            });
            const markerLength = marker.$marker.infoWindow.content.replace(/ /g, "").length;

            if(markerLength > 1 ){

                marker.$marker.infoWindow.open(this.map, marker.$marker);

                marker.$marker.addListener('click', () => {
                this.selectMarker(marker.$marker)
            });
            }


        });

        this.updateMarkerBounds();

        if (this.markers.length <= 1) {
            this.map.setCenter(new google.maps.LatLng(this.markers[0].getAttribute('data-lat'), this.markers[0].getAttribute('data-lng')));
            this.map.setZoom(13);
        } else {
            this.map.fitBounds(this.bounds);
        }
        if (document.querySelector('[data-js-map-select]')) {
            document.querySelector('[data-js-map-select]').addEventListener('change', (event) => {
                if (event.currentTarget.selectedIndex === 0) {
                    this.closeAllInfoWindows();
                    this.map.fitBounds(this.bounds);
                } else {
                    let index = event.currentTarget.selectedIndex - 1;
                    this.selectMarker(this.markers[index].$marker);
                }
            });
        }

    }
}

export default Map;

/*
let mapContainers;
const stylesHover =  [
    {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#444444"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "color": "#f2f2f2"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 45
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "color": "#d3d3d3"
            },
            {
                "visibility": "on"
            }
        ]
    }
];
const stylesNormal = [
    {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#444444"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "color": "#f2f2f2"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 45
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "color": "#fccf9c"
            },
            {
                "visibility": "on"
            }
        ]
    }
];

function renderGoogleMap() {
    mapContainers = document.querySelectorAll('dl.google-map-pp__map');


    [].forEach.call(mapContainers,  (el)=> {

        init(el);
    });
}

function init(mapContainer) {

    const locations = mapContainer.querySelectorAll('.google-map-pp__poi');
    const image = {
        url: mapContainer.getAttribute('data-map_ico'),
        scaledSize: new google.maps.Size(35, 48),
    };
    const map = new google.maps.Map(mapContainer, {
        styles: stylesNormal,
    });

    const infoWindow = new google.maps.InfoWindow();
    let bounds = new google.maps.LatLngBounds();

    [].forEach.call(locations, (el) => {
        const poiTitle = el.innerHTML;
        const poiLat = el.getAttribute('data-map_poi_lat');
        const poiLng = el.getAttribute('data-map_poi_lng');

        const markerPosition = new google.maps.LatLng(poiLat, poiLng);
        bounds.extend(markerPosition);


        const marker = new google.maps.Marker({
            position: markerPosition,
            map,
            icon: image,
        });

        google.maps.event.addListener(marker, 'click', (function (element) {
            return () => {
                infoWindow.setContent(poiTitle);
                infoWindow.open(map, element);
            };
        }(marker)));


        google.maps.event.addListener(map, 'mouseover', function(event) {

                map.setOptions({
                    styles : stylesHover
                });

            });

            google.maps.event.addListener(map, 'mouseout', function(event) {

                map.setOptions({
                    styles : stylesNormal
                });
            });




    });



    if (locations.length === 1)
    {
        let el = locations[0];
        const poiLat = el.getAttribute('data-map_poi_lat');
        const poiLng = el.getAttribute('data-map_poi_lng');
        const markerPosition = new google.maps.LatLng(poiLat, poiLng);
        map.setCenter(markerPosition);
        map.setZoom(14);
    }
    else
    {
        map.fitBounds(bounds);
    }

}

export default renderGoogleMap;
*/
